// extracted by mini-css-extract-plugin
export default {"contactForm":"styles_contactForm__-sr85","contactInner":"styles_contactInner__7XBjm"};